import React, { Component } from 'react';
import './BlastSetup.css';
import { Box, Button, Chip, Divider, FormControl, Grid, Grid2, IconButton, InputLabel, LinearProgress, List, ListItem, ListItemAvatar, ListItemText, MenuItem, Paper, Select, TextField, Tooltip } from '@mui/material';
import { ChevronLeft, ChevronRight, Close, FileOpen, Refresh, Search } from '@mui/icons-material';
import axios from 'axios';
import Global from '../../customlib/Global';
import Api from '../../customlib/Api';
import TemplateMessage from '../TemplateMessage';
import ucwords from 'ucwords';
import ReactPlayer from 'react-player';
import TemplateParamsInput from '../TemplateMessage/TemplateParamsInput';
import DateRangePicker from '../../customlib/DateRangePicker';
import moment from 'moment';

class BlastSetup extends Component {
    state = {

    }

    componentDidMount() {

    }

    render() {
        return (
            <Box>
                <BlastSetupMain {...this.props} state={this.props.state} />
            </Box>
        );
    }

}

export default BlastSetup;

class BlastSetupMain extends Component {
    state = {
        listAppProfiles: [],
        appTypeId: "",
        selectedAppProfile: null,
        selectedHsmName: "",
        selectedHsm: null,

        listTemplates: [],
        listTemplatesDisplay: [],
        debounceTimeout: null,
        query: "",
        queryChangeApplied: true,
        paging: {},
        counter: 0,
        isLoading: false,

        listUsers: [],
        countLavengerUser: 0,
        countNotLavengerUser: 0,
        listUserLavender: [],
        listUserLotus: [],
        keywordLavenderUser: "",
        keywordLotusUser: "",
        blastType: "ACQUISITION",

        runPeriod: "ONCE",

        blastObj: {
            appProfileId: "",
            hsmName: "",
            blastType: "ACQUISITION",
            customerOwners: [],
            blastPeriod: "CUSTOM_DAYS",
            startDate: null,
            endDate: null,
            startHour: "00:00",
            endHour: "00:00",
            days: [],
            blastDate: moment().tz("asia/jakarta").format("YYYY-MM-DD")
        },

        days: [
            {day: "SUNDAY", isSelected: true}, 
            {day: "MONDAY", isSelected: true}, 
            {day: "TUESDAY", isSelected: true}, 
            {day: "WEDNESDAY", isSelected: true}, 
            {day: "THURSDAY", isSelected: true}, 
            {day: "FRIDAY", isSelected: true}, 
            {day: "SATURDAY", isSelected: true}
        ]


    }

    handleAppTypeChanged = (event) => {
        const appProfiles = [...this.state.listAppProfiles];
        const selectedAppProfile = appProfiles.find(item => item._id === event.target.value);

        this.setState({ appTypeId: event.target.value, selectedAppProfile: selectedAppProfile }, () => {
            console.log(this.state.appTypeId, this.state.selectedAppProfile);
            // this.getLavengerUsers();
        });
    }

    loadAppProfile = () => {
        const params = {
        };

        axios
            .post(
                Api.listAppProfile(),
                params,
                Api.getRequestHeaderNoAuthNew()
            )
            .then((response) => {
                console.log("App Profiles", response.data);

                const profiles = response.data.data.filter((profile) => { return profile.enabled === true });

                this.setState({ listAppProfiles: profiles });
            })
            .catch((error) => {
                this.setState({ errorMessage: error.message, loginSuccess: false });
                console.error("There was an error!", error);
                // this.props.onLogin();
            });
    };

    loadUsersBySlugRoles = () => {
        
        const params = {
            // slugRoles: ["customer-service", "cs-purchase", "purchasing", "cs-payment", "rangkaian-bunga", "bd-staff-intern"]
            // slugRole: "account-executive"
        };
        console.log("BLASTTYPE", this.state.blastObj?.blastType);
        if(this.state.blastObj?.blastType === "ACQUISITION"){
            params.slugRoles = [
                "sales", "sales-data-pending", "admin-data-cancel", 
                "sales-acquisition","admin-ep", "admin-data-cancel"
            ];
        }else if(this.state.blastObj?.blastType === "RETENTION"){
            params.slugRoles = [
                "operational-tele-supervisor", "account-executive", 
                "nightshift", "tele-leader"
            ];
        }

        axios
        // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
        .post(Api.userBySlugRoles(), params, Api.getRequestHeader())
        .then((response) => {
            console.log("SALESTELEUSER : ", response.data.data);

            var users = response.data.data;

            users.forEach(user => {
                user.isLavengerUser = this.state.blastObj?.customerOwners?.includes(user.id);
            });

            var lotusUsers = users.filter(user => user.isLavengerUser === true);
            var lavenderUsers = users.filter(user => user.isLavengerUser === false);
            var countLavengerUser = lotusUsers.length;
            var countNotLavengerUser = lavenderUsers.length;

            console.log("LAVENGERUSERS : ", users);
            this.setState({ listUsers: users, listUserLavender: lavenderUsers, listUserLotus: lotusUsers, countLavengerUser: countLavengerUser, countNotLavengerUser: countNotLavengerUser });

            // let usersData = [{id: 0, name: "All CS"}];

            // response.data.data.forEach(item => {
            //     usersData.push(item);
            // });
            // this.setState({users: usersData});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };

    handleSearchValueChange = (event) => {
        let query = event.target.value !== null && event.target.value !== undefined ? event.target.value : "";
        // console.log("QUERY : ", event.target.value);
        // const listTemplate = [...this.state.listTemplates];
        // let search = listTemplate.filter((template) => template.labelName.toLowerCase().includes(query.toLowerCase()));

        // if(search.length > 0){
        //     this.setState({listTemplates: listTemplate, listTemplatesDisplay: search});
        // }

        // const query = event.target.value;

        // Membatalkan timer sebelumnya (jika ada)
        let oldDebounceTimeout = this.state.debounceTimeout;
        clearTimeout(oldDebounceTimeout);

        // Menunda request untuk 500ms setelah pengguna berhenti mengetik
        let newDebounceTimeout = setTimeout(() => {
            // this.setState({}, () => {
            this.getHsmTemplate();
            // });
        }, 500); // 500ms jeda waktu

        this.setState({ query: query, queryChangeApplied: false, debounceTimeout: newDebounceTimeout });

    };

    handleHeaderValueChange = (event) => {

        const templateData = { ...this.state.selectedHsm };
        if (templateData.header) {
            templateData.header.type = templateData.structure.header.format;
            templateData.header.imageUrl = event.target.value;
            templateData.header.description = "";
        } else {
            templateData.header = {
                type: templateData.structure.header.format,
                imageUrl: event.target.value,
                description: ""
            };
        }


        this.setState({ selectedHsm: templateData });

    };

    onKeyDownHandler = (e) => {

        if (e.keyCode === 13) {
            this.getHsmTemplate();
            this.setState({ queryChangeApplied: true });
        }
    };

    handleHsmSelectionChanged = (event) => {
        const listHsm = [...this.state.listTemplates];
        const findSelectedHsm = listHsm.find(item => item.name === event.target.value);

        this.setState({ selectedHsmName: event.target.value, selectedHsm: findSelectedHsm });
    }

    getHsmTemplate = (url = null) => {

        this.setState(
            { isLoading: true },
            () => {
                var userData = Global.get();
                // const messageData = this.props.messageData();
                const params = {
                    userId: userData.user.id,
                    waBussinesNumber: this.state.selectedAppProfile?.waNumber,
                    appProfileId: this.state.appTypeId,
                    loadUrl: url,
                    query: this.state.query
                };

                console.log("API URL : ", Api.getWaMessageTemplates());
                console.log("PARAMS : ", params);
                console.log("HEADER : ", Api.getRequestHeader());

                axios
                    .post(Api.getWaMessageTemplates(), params, Api.getRequestHeader())
                    .then((response) => {

                        console.log("MyCustomerToday : ", response.data.data.templates);
                        var responseData = response.data.data;
                        var templates = responseData.templates;
                        var paging = responseData.paging;

                        templates = templates.filter(item => item.status === "APPROVED");

                        templates.forEach(element => {
                            element.labelName = ucwords(element.name.replaceAll("_", " "));
                            let count = (element.structure.body.match(/{{/g) || []).length;
                            var params = [];
                            for (var i = 0; i < count; i++) {
                                params.push({ paramValue: "", paramIndex: i, paramLabel: i + 1 });
                            }
                            element.params = params;
                        });

                        console.log("TEMPLATES : ", templates);

                        this.setState({ listTemplates: templates, paging: paging, counter: responseData.counter, listTemplatesDisplay: templates, isLoading: false }, () => { console.log(this.state.listTemplates) });
                        // this.setState({listSales: response.data.data});
                    })
                    .catch((error) => {
                        this.setState({ isLoading: false });
                        console.error("There was an error!", userData.user.id, error);
                    });
            }
        );

    };

    handleUpdateParamValue = (templateId, paramIndex, paramValue) => {
        console.log(templateId, paramIndex, paramValue);

        const clonedTemplates = [...this.state.listTemplates];
        let template = clonedTemplates.filter((template) => template.id === templateId);

        if (template.length > 0) {
            template[0].params[paramIndex].paramValue = paramValue;
        }

        console.log("FOUNDTEMPLATE", template);

        this.setState({ listTemplates: clonedTemplates }, () => { console.log("UPDATEDTEMPLATES : ", this.state.listTemplates); });

    }

    getLavengerUsers = () => {

        const params = {
            appProfileId: this.state.selectedAppProfile?._id
        };

        axios
            .post(Api.lavengerUsersList(), params, Api.getRequestHeader())
            .then((response) => {

                console.log("LAVENGER USERS : ", response.data);

                var users = response.data.data;
                var lotusUsers = users.filter(user => user.isLavengerUser === true);
                var lavenderUsers = users.filter(user => user.isLavengerUser === false);
                var countLavengerUser = lotusUsers.length;
                var countNotLavengerUser = lavenderUsers.length;

                console.log("LAVENGERUSERS : ", users);
                this.setState({ listUsers: users, listUserLavender: lavenderUsers, listUserLotus: lotusUsers, countLavengerUser: countLavengerUser, countNotLavengerUser: countNotLavengerUser });
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
    };

    filterUserLavender = (keyword) => {
        return this.state.listUsers.filter(user => user.isLavengerUser === false &&
            (
                user.email.toLowerCase().includes(`${keyword}`.toLowerCase()) ||
                user.name.toLowerCase().includes(`${keyword}`.toLowerCase())
            )
        );
    }

    filterUserLotus = (keyword) => {
        return this.state.listUsers.filter(user => user.isLavengerUser === true &&
            (
                user.email.toLowerCase().includes(`${keyword}`.toLowerCase()) ||
                user.name.toLowerCase().includes(`${keyword}`.toLowerCase())
            )
        );
    }

    handleMoveUser = (userData) => {
        const users = [...this.state.listUsers];
        var findUser = users.filter(user => user.id === userData.id);


        try {
            if (findUser.length > 0) {
                findUser[0].isLavengerUser = !findUser[0].isLavengerUser;
            }

            var countLavengerUser = users.filter(user => user.isLavengerUser === true).length;
            var countNotLavengerUser = users.filter(user => user.isLavengerUser === false).length;
            this.setState(
                {
                    listUsers: users,
                    countLavengerUser: countLavengerUser,
                    countNotLavengerUser: countNotLavengerUser,
                    message: "Perubahan belum disimpan, klik tombol simpan"
                }
            );

        } catch (err) {
            console.log(err);
        }


    }

    handleBlastTypeChanged = (event) => {
        const blastObj = {...this.state.blastObj};
        blastObj.blastType = event.target.value;
        this.setState({ blastObj: blastObj }, this.loadUsersBySlugRoles);
    }

    handleBlastPeriodChanged = (event) => {
        const blastObj = {...this.state.blastObj};
        const days = [...this.state.days];
        blastObj.blastPeriod = event.target.value;

        if(blastObj.blastPeriod === "EVERYDAY"){
            days.forEach(item => {item.isSelected = true});
        }else if(blastObj.blastPeriod === "CUSTOM_DAYS"){
            days.forEach(item => {item.isSelected = false});
        }

        this.setState({ blastObj: blastObj, days: days });
    }

    handleDaysSelectionChange = (selectedDay) => {
        const days = [...this.state.days];
        const findDay = days.find(item => item.day === selectedDay.day);

        if(findDay){
            findDay.isSelected = !selectedDay.isSelected;
            const findSelectedOnly = days.filter(item => item.isSelected === true);
            const blastObj = {...this.state.blastObj};
            blastObj.days = [];
            findSelectedOnly.forEach(day => {
                blastObj.days.push(day);
            })
            this.setState({days: days});
        }
    }

    handleDateChanged = (event) => {
        console.log(event.target.value);
        let selectedDate = event.target.value;
        const obj = {...this.state.blastObj};
        obj.blastDate = selectedDate;
        this.setState({blastObj: obj}, () => {
            // this.getContactLeads();
        });
    }

    handleSubmit = () => {
        const blastObj = {...this.state.blastObj};

        console.log("SUBMIT_DATA", blastObj);
        
    }

    componentDidMount() {
        this.loadAppProfile();
        this.loadUsersBySlugRoles();
        // this.getLavengerUsers();
        // this.getHsmTemplate();
    }

    handleKeywordLavenderChanged = (event) => {
        this.setState({keywordLavenderUser: event.target.value});
    }

    handleKeywordLotusChanged = (event) => {
        this.setState({keywordLotusUser: event.target.value});
    }

    render() {
        return (
            <Box sx={{ padding: "20px" }}>
                <Grid container spacing={1}>
                    <Grid item xs={11}>
                        <h4>Setup Blast</h4>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "right" }}>
                        <IconButton
                            color='error'
                            size='small'
                            onClick={this.props.onClose}
                        >
                            <Close />
                        </IconButton>
                    </Grid>
                </Grid>
                <Divider />
                {/* <br /> */}
                <Grid container spacing={0} sx={{mt: "5px"}}>
                    <Grid item xs={5}>
                        {/* <h5>Waktu Blast</h5> */}
                        <Box sx={{ mt: "10px" }}>
                            {/* <Box sx={{mb: "10px"}}>Setup kapan blast berjalan</Box> */}
                            <FormControl variant="outlined" size="small" fullWidth>
                                <InputLabel id="label-pelaksanaan-blast">Pelaksanaan</InputLabel>
                                <Select
                                    labelId="label-pelaksanaan-blast"
                                    id="label-pelaksanaan-blast"
                                    value={this.state.blastObj?.blastPeriod}
                                    onChange={this.handleBlastPeriodChanged}
                                    label="Aplikasi"
                                >
                                    {/* <MenuItem key={"key-once"} value={"ONCE"}>Sekali Saja</MenuItem> */}
                                    {/* <MenuItem key={"key-everyday"} value={"EVERYDAY"}>Setiap Hari</MenuItem> */}
                                    <MenuItem key={"key-on-days"} value={"CUSTOM_DAYS"}>Pada Hari</MenuItem>
                                    <MenuItem key={"key-ondate"} value={"ON_DATE"}>Pada Tanggal</MenuItem>
                                </Select>
                            </FormControl>


                        </Box>
                    </Grid>
                    <Grid item xs={7}>
                        {/* <h5>Waktu Blast</h5> */}
                        <Box sx={{ mt: "10px", ml: "10px" }}>
                            {/* <Box sx={{mb: "10px"}}>Setup kapan blast berjalan</Box> */}
                            {
                                ["EVERYDAY", "CUSTOM_DAYS"].includes(this.state.blastObj?.blastPeriod) && this.state.days.map(item => {
                                    return (
                                        <Chip 
                                            label={item.day} 
                                            color={item.isSelected ? "primary" : "deefault"}
                                            variant={item.isSelected ? "contained" : "outlined"}
                                            size='small'
                                            sx={{ml: "5px", mr: "5px", textTransform: "capitalize"}}
                                            onClick={this.state.blastObj?.blastPeriod === "EVERYDAY" ? ()=>{} : () => this.handleDaysSelectionChange(item)} 
                                        />
                                    );
                                })
                            }

                            {
                                this.state.blastObj?.blastPeriod === "ON_DATE" && (
                                    <TextField
                                        id="tanggal"
                                        label="Tanggal"
                                        value={this.state.blastObj?.blastDate}
                                        onChange={this.handleDateChanged}
                                        type="date"
                                        size='small'
                                    />
                                )
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={5} sx={{ border: "solid 0px #dededd", borderRadius: "10px", mt: "10px" }}>
                        <Paper elevation={0} sx={{ p: "10px", mr: "5px" }}>
                            <h5>HSM Setup</h5>
                            <Box sx={{ mt: "10px" }}>
                                <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                                    <InputLabel id="demo-simple-select-outlined-label">Pilih Aplikasi</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={this.state.appTypeId}
                                        onChange={this.handleAppTypeChanged}
                                        label="Aplikasi"
                                    >
                                        {
                                            this.state.listAppProfiles.map(
                                                (profile) => {
                                                    return (<MenuItem key={profile._id} value={profile._id}>{profile.label}</MenuItem>);
                                                }
                                            )
                                        }
                                    </Select>
                                </FormControl>

                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField
                                            onKeyDown={this.onKeyDownHandler}
                                            onChange={this.handleSearchValueChange}
                                            label="Cari nama HSM"
                                            type="text"
                                            className="form-control"
                                            variant="outlined"
                                            size='small'
                                            value={this.state.query}
                                            disabled={this.state.selectedAppProfile === null}
                                            sx={{ mt: "10px" }}
                                        />
                                        {
                                            this.state.isLoading && <LinearProgress />
                                        }

                                        {
                                            this.state.queryChangeApplied === false && (
                                                <Box sx={{ fontSize: "10px", marginTop: "5px", color: "red" }}>Tekan <strong>ENTER</strong> atau <Search sx={{ width: "15px" }} /> untuk apply pencarian</Box>
                                            )
                                        }

                                    </Grid>
                                    {/* <Grid item xs={1}>
                                        <Tooltip title={"Cari nama HSM"}>
                                            <IconButton color='primary' disabled={this.state.isRekomendasiMode} onClick={() => this.getHsmTemplate()}><Search /></IconButton>
                                        </Tooltip>
                                    </Grid> */}
                                    {/* <Grid item xs={1}>
                                        <Tooltip title={"Reload HSM"}>
                                            <IconButton color='warning' onClick={() => this.getHsmTemplate()}><Refresh /></IconButton>
                                        </Tooltip>
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <FormControl variant="outlined" sx={{ width: '100%', mt: "10px" }} size="small">
                                            <InputLabel id="cb-hsm">Pilih HSM</InputLabel>
                                            <Select
                                                labelId="cb-hsm"
                                                id="cb-hsm"
                                                value={this.state.selectedHsmName}
                                                onChange={this.handleHsmSelectionChanged}
                                                label="HSM"
                                                disabled={this.state.listTemplates.length <= 0}
                                            >
                                                {
                                                    this.state.listTemplates?.map(
                                                        (hsm) => {
                                                            return (<MenuItem key={hsm.id} value={hsm.name}>{hsm.labelName}</MenuItem>);
                                                        }
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        {
                                            this.state.selectedHsm && (
                                                <div className="container border border-warning rounded" style={{ marginBottom: 5 }}>
                                                    <Box>
                                                        {/* <h5>
                                                        {ucwords(this.state.selectedHsm.name.replaceAll("_", " "))}
                                                    </h5> */}
                                                        <span className={this.state.selectedHsm.category === "MARKETING" ? "badge badge-danger" : "badge badge-success"}><small>{ucwords(this.state.selectedHsm.category.replaceAll("_", " ").toLowerCase())}</small></span>
                                                    </Box>
                                                    {/* <div className="row">
                                                    <div className="col-9">
                                                        <h5>
                                                            {ucwords(this.state.selectedHsm.name.replaceAll("_", " "))}
                                                        </h5>
                                                        <span className={this.state.selectedHsm.category === "MARKETING" ? "badge badge-danger" : "badge badge-success"}><small>{ucwords(this.state.selectedHsm.category.replaceAll("_", " ").toLowerCase())}</small></span>
                                                    </div>
                                                    <div className="col-2 text-right">
                                                        button
                                                        {
                                                            this.state.isSending && this.state.sendingTemplateId===template.id ? 
                                                            (
                                                                // <></>
                                                                <ReactLoading color="#FF0000" type="bubbles" width={50} height={10}/>
                                                            ) : 
                                                            (
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {this.handleSendTemplate(template)}}
                                                                    // className={classes.button}
                                                                    endIcon={ <Send />}
                                                                    disabled={template.hsmEnabled === false}
                                                                >
                                                                    Kirim
                                                                </Button>
                                                            )
                                                        }
                                                        
                                                        
                                                    </div>
                                                </div> */}
                                                    <hr />
                                                    {
                                                        !this.state.selectedHsm.isAllInputvalid && <Box>{this.state.selectedHsm.errMessage}</Box>
                                                    }
                                                    {this.state.selectedHsm.structure.body}
                                                    {
                                                        this.state.selectedHsm.structure.header !== undefined && this.state.selectedHsm.structure.header.format === "IMAGE" ?
                                                            (
                                                                <div className="container-fluid">
                                                                    <hr />
                                                                    {/* {
                                                                    this.state.selectedHsm.hsmEnabled === false ? (<div className="btn btn-secondary btn-block disabled">
                                                                    Pilih Gambar
                                                                </div>) : (<div className="btn btn-primary btn-block" onClick={(event) => this.handleOpenListHsmImage(event, this.state.selectedHsm)}>
                                                                    Pilih Gambar
                                                                </div>)
                                                                } */}
                                                                    <br />
                                                                    <div className="container-fluid text-center">
                                                                        {
                                                                            this.state.selectedHsm.header === undefined ? "Gambar belum dipilih" :
                                                                                (
                                                                                    <div className='text-center'>
                                                                                        <img src={this.state.selectedHsm.header.imageUrl} style={{ maxWidth: "100%", maxHeight: "200px" }} />
                                                                                        <br />
                                                                                        {this.state.selectedHsm.header.description}
                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            ) :
                                                            this.state.selectedHsm.structure.header !== undefined && this.state.selectedHsm.structure.header.format === "VIDEO" ?
                                                                (
                                                                    <div className="container-fluid">
                                                                        <hr />
                                                                        {/* {
                                                                    this.state.selectedHsm.hsmEnabled === false ? (<div className="btn btn-secondary btn-block disabled">
                                                                    Pilih Video
                                                                </div>) : (<div className="btn btn-primary btn-block" onClick={(event) => this.handleOpenListHsmImage(event, this.state.selectedHsm)}>
                                                                    Pilih Video
                                                                </div>)
                                                                } */}
                                                                        <br />
                                                                        <div className="container-fluid text-center">
                                                                            {
                                                                                this.state.selectedHsm.header === undefined ? "Video belum dipilih" :
                                                                                    (
                                                                                        <div className='text-center'>
                                                                                            {/* <img src={template.header.imageUrl} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                            {/* <img src={"https://lotus.prestisa.id/lavenger-backend/public/videos/08a12b53600665f78cc1071510327b62.mp4"} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                            {/* <ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseVideosUrl() + data.message.fileName} /> */}
                                                                                            <ReactPlayer width="100%" style={{ maxHeight: "250px" }} controls={true} url={this.state.selectedHsm.header.imageUrl} />
                                                                                            <br />
                                                                                            {this.state.selectedHsm.header.description}
                                                                                        </div>
                                                                                    )
                                                                            }
                                                                        </div>

                                                                    </div>
                                                                ) :
                                                                this.state.selectedHsm.structure.header !== undefined && this.state.selectedHsm.structure.header.format === "DOCUMENT" ?
                                                                    (
                                                                        <div className="container-fluid">
                                                                            <hr />
                                                                            {/* {
                                                                    this.state.selectedHsm.hsmEnabled === false ? (<div className="btn btn-secondary btn-block disabled">
                                                                    Pilih Dokumen
                                                                </div>) : (<div className="btn btn-primary btn-block" onClick={(event) => this.handleOpenListHsmImage(event, this.state.selectedHsm)}>
                                                                    Pilih Dokumen
                                                                </div>)
                                                                } */}

                                                                            <br />
                                                                            <div className="container-fluid text-center">
                                                                                {
                                                                                    this.state.selectedHsm.header === undefined ? "Dokumen URL Belum Ditentukan" :
                                                                                        (
                                                                                            <div className='text-center'>
                                                                                                <FileOpen />
                                                                                                {/* <img src={template.header.imageUrl} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                                {/* <img src={"https://lotus.prestisa.id/lavenger-backend/public/videos/08a12b53600665f78cc1071510327b62.mp4"} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                                {/* <ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseVideosUrl() + data.message.fileName} /> */}
                                                                                                {/* <ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={template.header.imageUrl} /> */}
                                                                                                <br />
                                                                                                {this.state.selectedHsm.header.description}
                                                                                            </div>
                                                                                        )
                                                                                }
                                                                            </div>

                                                                        </div>
                                                                    ) :
                                                                    (<></>)
                                                    }
                                                    {
                                                        this.state.selectedHsm.structure.header !== undefined && (
                                                            <TextField
                                                                onChange={this.handleHeaderValueChange}
                                                                label={`${this.state.selectedHsm.structure.header.format} URL`}
                                                                type="text"
                                                                className="form-control"
                                                                variant="outlined"
                                                                size='small'
                                                                value={this.state.selectedHsm.header?.imageUrl}
                                                                sx={{ mt: "10px" }}
                                                            />
                                                        )
                                                    }

                                                    <hr />
                                                    {
                                                        this.state.selectedHsm.params.map(
                                                            (param) => {
                                                                return (
                                                                    <TemplateParamsInput
                                                                        templateData={this.state.selectedHsm}
                                                                        paramData={param}
                                                                        onUpdateData={this.handleUpdateParamValue}
                                                                        disabled={this.state.selectedHsm.hsmEnabled === false}
                                                                    />);
                                                            }
                                                        )
                                                    }


                                                </div>
                                            )
                                        }
                                    </Grid>
                                </Grid>

                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={7} sx={{ border: "solid 0px #dededd", borderRadius: "10px", mt: "10px" }}>
                        <Paper elevation={0} sx={{ p: "10px", ml: "5px" }}>
                            <h5>Database Setup</h5>
                            <Grid container spacing={1} sx={{ mt: "0px" }}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                                        <InputLabel id="label-blast-type">Tipe Blast</InputLabel>
                                        <Select
                                            labelId="label-blast-type"
                                            id="select-blast-type"
                                            value={this.state.blastObj?.blastType}
                                            onChange={this.handleBlastTypeChanged}
                                            label="Aplikasi"
                                        >
                                            <MenuItem key={"key-acquisition"} value={"ACQUISITION"}>Acquisition</MenuItem>
                                            <MenuItem key={"key-retention"} value={"RETENTION"}>Retention</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}></Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ mt: "10px" }}>
                                <Grid item xs={6}>
                                    <Paper elevation={1} style={{ width: "100%", padding: 10 }}>
                                        <div className="row">
                                            <div className="col-9">
                                                <h4>User Lavender</h4>
                                            </div>
                                            <div className="col-2 text-right">
                                                <div style={{ marginBottom: 10 }} className="badge badge-primary">{this.state.countNotLavengerUser} User</div>
                                            </div>
                                        </div>
                                        {/* <Divider sx={{marginTop: "5px", marginBottom: "5px"}} /> */}
                                        <TextField
                                            id="txt-keyword-lavender"
                                            label="pencarian user"
                                            variant="outlined"
                                            type='text'
                                            onChange={this.handleKeywordLavenderChanged}
                                            value={this.state.keywordLavenderUser}
                                            fullWidth
                                            size='small'
                                        />
                                        <List style={{ maxHeight: 470, overflowY: "scroll", marginTop: "10px" }}>
                                            {
                                                // this.state.listUsers.filter(user => user.isLavengerUser === false).map(user => 
                                                this.filterUserLavender(this.state.keywordLavenderUser).map(user =>
                                                (
                                                    <ListItem sx={{ cursor: "pointer" }} dense key={user.id} onClick={() => { this.handleMoveUser(user) }}
                                                        secondaryAction={
                                                            // <IconButton edge="end" aria-label="delete">
                                                            <ChevronRight style={{ marginTop: 5 }} />
                                                            // </IconButton>
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={user.name}
                                                            secondary={user.email}
                                                        />
                                                    </ListItem>
                                                )
                                                    // (<ListItem button key={user.id} onClick={() => {this.handleMoveUser(user)}}>
                                                    //     <div className="row">
                                                    //         <div className="col-11">
                                                    //             <ListItemText primary={user.name + " - " + user.email} />
                                                    //         </div>
                                                    //         <div className="col-1">
                                                    //             <ChevronRight style={{marginTop: 5}} />
                                                    //         </div>
                                                    //     </div>
                                                    // </ListItem>)
                                                )
                                            }
                                        </List>
                                    </Paper>
                                </Grid>
                                {/* <div className="col-2"></div> */}
                                <Grid item xs={6}>
                                    <Paper elevation={1} style={{ width: "100%", padding: 10 }}>
                                        <div className="row">
                                            <div className="col-9">
                                                <h4>Owner Customer Blast</h4>
                                            </div>
                                            <div className="col-2 text-right">
                                                <div style={{ marginBottom: 10 }} className="badge badge-primary">{this.state.countLavengerUser} User</div>
                                            </div>
                                        </div>
                                        {/* <Divider sx={{marginTop: "5px", marginBottom: "5px"}} /> */}
                                        <TextField
                                            id="txt-keyword-lotus"
                                            label="pencarian user"
                                            variant="outlined"
                                            type='text'
                                            onChange={this.handleKeywordLotusChanged}
                                            value={this.state.keywordLotusUser}
                                            fullWidth
                                            size='small'
                                        />
                                        <List style={{ maxHeight: 470, overflowY: "scroll", marginTop: "10px" }}>
                                            {
                                                // this.state.listUsers.filter(user => user.isLavengerUser === true).map(user => 
                                                this.filterUserLotus(this.state.keywordLotusUser).map(user =>
                                                (
                                                    <ListItem dense key={user.id} sx={{ cursor: "pointer" }} onClick={() => { this.handleMoveUser(user) }} >
                                                        <ListItemAvatar>
                                                            <ChevronLeft />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={user.name}
                                                            secondary={user.email}
                                                        />
                                                    </ListItem>
                                                )
                                                    //     (<ListItem button key={user.id} onClick={() => {this.handleMoveUser(user)}}>
                                                    //     <div className="row">
                                                    //         <div className="col-1 text-left">
                                                    //             <ChevronLeft style={{marginTop: 5}} />
                                                    //         </div>
                                                    //         <div className="col-11">
                                                    //             <ListItemText primary={user.name + " - " + user.email} />
                                                    //         </div>
                                                    //     </div>
                                                    // </ListItem>)
                                                )
                                            }

                                        </List>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                </Grid>

                <Divider />
                <Box textAlign={"right"} sx={{mt: '10px'}}>
                    <Button onClick={this.handleSubmit} color='primary' variant='contained' sx={{mr: "10px",textTransform: "capitalize"}}>Submit</Button>
                    <Button color='error' variant='outlined' sx={{textTransform: "capitalize"}}>Cancel</Button>
                </Box>
            </Box>
        );
    }
}